import axios from 'axios';
import { versionHash } from '../main';

const VersionCheck = () => {
  let currentHash = versionHash;
  let newHash = '';

  const isUpdateAvailable = async () => {
    try {
      const fileResponse = await axios.get(
        `/version.json?t=${new Date().getTime()}`,
        { baseURL: window.location.origin }
      );
      newHash = fileResponse.data.hash;
      return hasHashChanged(currentHash, newHash);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  const hasHashChanged = (currentHash, newHash) => {
    if (!currentHash || currentHash === versionHash) {
      return false;
    }

    return currentHash !== newHash;
  };

  const reloadApp = () => {
    currentHash = newHash;
    window.location.reload();
  };

  return {
    isUpdateAvailable,
    reloadApp,
  };
};

export default VersionCheck;
